var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      {
        staticClass: "list-card van-hairline--surround",
        on: {
          click: function($event) {
            return _vm.linkTo(_vm.item)
          }
        }
      },
      [
        _c("div", { staticClass: "list-line clear" }, [
          _c("p", { staticClass: "list-title fl" }, [_vm._v("门店:")]),
          _vm._v(" "),
          _c("p", { staticClass: "list-content fl" }, [
            _vm._v(_vm._s(_vm.item.deptName))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-line clear" }, [
          _c("p", { staticClass: "list-title fl" }, [_vm._v("活动:")]),
          _vm._v(" "),
          _c("p", { staticClass: "list-content fl" }, [
            _vm._v(_vm._s(_vm.item.campName))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-line clear" }, [
          _c("p", { staticClass: "list-title fl" }, [_vm._v("日期:")]),
          _vm._v(" "),
          _c("p", { staticClass: "list-content fl" }, [
            _vm._v(
              _vm._s(
                (_vm.item.campTime || "").replace(/-/g, "/").replace(",", "-")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-line clear" }, [
          _c("p", { staticClass: "list-title fl" }, [_vm._v("地点:")]),
          _vm._v(" "),
          _c("p", { staticClass: "list-content fl" }, [
            _vm._v(_vm._s(_vm.item.U_CampPlace))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-line clear" }, [
          _c("p", { staticClass: "list-title fl" }, [_vm._v("实际费用:")]),
          _vm._v(" "),
          _c("p", { staticClass: "list-content fl" }, [
            _vm._v(_vm._s(_vm.$numeral(_vm.item.totalCost).format("0,0.00")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }, [
          _c("p", { staticClass: " fl" }, [_vm._v("活动后30天销售情况:")]),
          _vm._v(" "),
          _c("p", { staticClass: "list-content fl" }, [
            _vm._v(_vm._s(_vm.item.monthSalesCnt <= 0 ? "未提交" : "已提交"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-status" }, [
          _vm._v("\n      " + _vm._s(_vm.item.approvalStatusName) + "\n      "),
          _vm.item.U_ApprovalStatus == "W"
            ? _c("p", [_vm._v("(" + _vm._s(_vm.item.auditName) + ")")])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b0e5e82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0e5e82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/component/reportCard.vue
// module id = null
// module chunks = 